module.exports = __webpack_public_path__ + "img/visa-mastercard.9b7ee40d.png";